$(document).ready(function(){

$('[data-popup-open]').on('click', function (e) {
  var targeted_popup_class = $(this).attr('data-popup-open');
  var scrollPosition = $(window).scrollTop(); // Get the current scroll position

  $('[data-popup="' + targeted_popup_class + '"]').fadeIn(350);
  $('[data-popup="' + targeted_popup_class + '"]').addClass('activePopup');
  e.preventDefault();

  // Add lock class and fix position
  $('body').addClass('lock').css({
    position: 'fixed',
    top: -scrollPosition + 'px', // Prevent scroll jump
    width: '100%',
  });

  $('.popupOverlay').fadeIn(350);
  // Store the scroll position for unlocking later
  $('body').data('scroll-position', scrollPosition);
});   
  
$('[data-popup-close]').on('click', function (e) {
  var targeted_popup_class = $(this).attr('data-popup-close');
  var scrollPosition = $('body').data('scroll-position'); // Get stored scroll position

  $('[data-popup="' + targeted_popup_class + '"]').fadeOut(350);
  $('[data-popup="' + targeted_popup_class + '"]').removeClass('activePopup');
  e.preventDefault();

  // Remove lock class and restore position
  $('body').removeClass('lock').css({
    position: '',
    top: '',
    width: '',
  });
  // $('html').removeClass('lock');
  $(window).scrollTop(scrollPosition); // Restore scroll position
  $('.popupOverlay').fadeOut(350);
});
  
$('input[name="addon"]').on('change', function () {       
    var basePriceStr = $(this).attr('data-price'); // Addon price
    var addonPriceStr = $(this).attr('data-price-base'); // Base product price (seems you mixed comments, corrected)
    var dataProductId = $(this).attr('data-product-id');    
    
    // Remove currency symbol (€) and parse properly (comma to dot too!)
    var basePrice = parseFloat(basePriceStr.replace('€', '').replace(',', '.'));
    var addonPrice = parseFloat(addonPriceStr.replace('€', '').replace(',', '.'));    
    
    var selectedQty = $('.activePopup .addOnQty').val() || 1; // Always fallback to 1 if empty (smart fallback)
    var totalPrice = (addonPrice + basePrice) * selectedQty;    

    $('#quantity-' + dataProductId).val(selectedQty);

    var formattedPrice = totalPrice.toFixed(2).replace('.', ',');

    $('[data-product-id="' + dataProductId + '"] .confirmPrice').text(formattedPrice + ' €');
});

$('.confirmAddon').on('click', function (e) {
  e.preventDefault();    

  var productId = $(this).data('product-id');
  var variantId = $(this).data('variant-id');
  var productTag = $(this).data('tag');
  var prodQty =  $('#quantity-'+productId).val();
  var targetedPopupClass = `popup-${productId}`;    
  var selectedAddon = $(`#addonForm-${productId} input[name="addon"]:checked`);  
  var addonId = selectedAddon.val();
  if(selectedAddon.length !== 0 && selectedAddon.data('price') !== '0,00 €' ){        
    var addonTitle = selectedAddon.data('title'); // Get the add-on title
    var addonQty = $(`#addOnQty${productId}`).val(); // Get the add-on quantity        
    var addonbasePrice  = parseFloat(selectedAddon.data('price').replace('€', ''));
    var addonprice  = addonbasePrice * addonQty;
    // Combine title and quantity into a single string
    var addonDetails = `${addonTitle}`;       
    $(`#addOnProduct-${productId}`).val(addonDetails);    
    var addonId = selectedAddon.val();
    var productTitle = $(this).data('product-title');

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: addonId,
        quantity: addonQty,
        properties: {
          'Beilage für': productTitle
        }
      },
      dataType: 'json',
      success: function (data) {

          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              id: variantId,
              quantity: prodQty,
              properties: {
                'Beilage': selectedAddon.data('title') 
              }
            },
            dataType: 'json',
            success: function (data) {
              fetch(`${Shopify.routes.root}cart.js`)
                .then(response => response.json())
                .then(cartContent => {
                  cartContent["sections"] = data["sections"]; // Assuming 'sections' comes from /cart/add.js
                  document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                    bubbles: true,
                    detail: {
                      baseEvent: "variant:add",
                      cart: cartContent
                    }
                  }));

                    document.dispatchEvent(new CustomEvent("cart:refresh"));
          
                    $(`[data-popup="${targetedPopupClass}"]`).fadeOut(350); // Close popup
                    $('body').removeClass('lock');
                    $('html').removeClass('lock');
                    $('.popupOverlay').fadeOut(350);
                });  
                  $('body').removeClass('lock');
                  $('html').removeClass('lock');
            
            },
            error: function (xhr, status, error) { 
              console.error('Error adding addon:', error);
            },
          });



        
        // $(`.${targetedPopupClass} button`).click(); // Trigger popup close button click          
        // $(`[data-popup="${targetedPopupClass}"]`).fadeOut(350); // Close popup
        // $('body').removeClass('lock');
        // $('.popupOverlay').fadeOut(350);
        // $('.productBlock input[type="radio"]').prop('checked',false);
      },
      error: function (xhr, status, error) { 
        console.error('Error adding addon:', error);
      },
    });
  }
  else{

    if(productTag && productTag == "Mittagsmenue-Angebot"){

       $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variantId,
        quantity: prodQty,
        properties: {
          'Gratis Vorspeise': selectedAddon.data('title')
        }
      },
      dataType: 'json',
      success: function (data) {
            fetch(`${Shopify.routes.root}cart.js`)
            .then(response => response.json())
            .then(cartContent => {
              cartContent["sections"] = data["sections"]; // Assuming 'sections' comes from /cart/add.js
              document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                bubbles: true,
                detail: {
                  baseEvent: "variant:add",
                  cart: cartContent
                }
              }));

                document.dispatchEvent(new CustomEvent("cart:refresh"));
      
                $(`[data-popup="${targetedPopupClass}"]`).fadeOut(350); // Close popup
                $('body').removeClass('lock'); 
                $('html').removeClass('lock'); 
                $('.popupOverlay').fadeOut(350);
            });    
          $('body').removeClass('lock');
                  $('html').removeClass('lock');
      },
      error: function (xhr, status, error) { 
        console.error('Error adding addon:', error);
      },
    });

    }else{
   $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variantId,
        quantity: prodQty,
        properties: {
          'Beilage': selectedAddon.data('title')
        }
      },
      dataType: 'json',
      success: function (data) {
            fetch(`${Shopify.routes.root}cart.js`)
            .then(response => response.json())
            .then(cartContent => {
              console.log(data);
              console.log(cartContent);
              cartContent["sections"] = data["sections"]; // Assuming 'sections' comes from /cart/add.js
              document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                bubbles: true,
                detail: {
                  baseEvent: "variant:add",
                  cart: cartContent
                }
              }));

                document.dispatchEvent(new CustomEvent("cart:refresh"));
      
                $(`[data-popup="${targetedPopupClass}"]`).fadeOut(350); // Close popup
                $('body').removeClass('lock'); 
                $('html').removeClass('lock'); 
                $('.popupOverlay').fadeOut(350);
            });    
          $('body').removeClass('lock');
                  $('html').removeClass('lock');
      },
      error: function (xhr, status, error) { 
        console.error('Error adding addon:', error);
      },
    });
    }

   
    

        // $(`#addOnProduct-${productId}`).val(selectedAddon.data('title'));
        // $(`.${targetedPopupClass} button`).click(); // Trigger popup close button click          
        // $(`[data-popup="${targetedPopupClass}"]`).fadeOut(350); // Close popup
        // $('body').removeClass('lock');
        // $('.popupOverlay').fadeOut(350);
  }
});

  var prevValSingle = '';
$(document).on('click', '.activePopup .plusButtonSingle', function (e) {
    prevValSingle = $(this).siblings('.addOnQty').val();
    var selectedAddon = $(this);
    var dataProductId = selectedAddon.attr('data-product-id');
    var basePriceStr = selectedAddon.attr('data-price-base');

    // Remove € symbol and fix comma to dot for float parsing
    var basePrice = parseFloat(basePriceStr.replace('€', '').replace(',', '.'));

    var selectedQty = $('.activePopup .addOnQty').val();
    $('#quantity-' + dataProductId).val(selectedQty);

    var totalPrice = basePrice * selectedQty;

    // Force always two decimals and replace dot with comma
    var formattedPrice = totalPrice.toFixed(2).replace('.', ',');

    $('[data-product-id="' + dataProductId + '"] .confirmPrice').text(formattedPrice + ' €');
});

$(document).on('click', '.activePopup .MinusButtonSingle', function (e) {
    if ($(this).siblings('.addOnQty').val() > 1 || prevValSingle == 2) {
        var selectedAddon = $(this);
        var dataProductId = selectedAddon.attr('data-product-id');
        
        var basePriceStrProduct = selectedAddon.attr('data-price-base'); 
        var basePriceProduct = parseFloat(basePriceStrProduct.replace('€', '').replace(',', '.'));

        var selectedQty = $('.activePopup .addOnQty').val();
        $('#quantity-' + dataProductId).val(selectedQty);

        var totalPrice = basePriceProduct * selectedQty;
        var formattedPrice = totalPrice.toFixed(2).replace('.', ',');

        $('[data-product-id="' + dataProductId + '"] .confirmPrice').text(formattedPrice + ' €');
    }
    prevValSingle = $(this).siblings('.addOnQty').val();
});

var prevVal = '';

$(document).on('click', '.activePopup .plusButton', function (e) {
    prevVal = $(this).siblings('.addOnQty').val();
    
    var selectedAddon = $(this).closest('.productBlockBtn')
                               .parent('.addonProductWrapper')
                               .find('.addonRow form input[name="addon"]:checked');
    
    var dataProductId = selectedAddon.attr('data-product-id');
    var basePriceStr = selectedAddon.attr('data-price-base');
    var addonPriceStr = selectedAddon.attr('data-price');

    var basePrice = parseFloat(basePriceStr.replace('€', '').replace(',', '.'));
    var addonPrice = parseFloat(addonPriceStr.replace('€', '').replace(',', '.'));
    
    var selectedQty = $('.activePopup .addOnQty').val();
    $('#quantity-' + dataProductId).val(selectedQty);

    var totalPrice = (basePrice + addonPrice) * selectedQty;
    var formattedPrice = totalPrice.toFixed(2).replace('.', ',');

    $('[data-product-id="' + dataProductId + '"] .confirmPrice').text(formattedPrice + ' €');
});

$(document).on('click', '.activePopup .MinusButton', function (e) {
    if ($(this).siblings('.addOnQty').val() > 1 || prevVal == 2) {
        var selectedAddon = $(this).closest('.productBlockBtn')
                                   .parent('.addonProductWrapper')
                                   .find('.addonRow form input[name="addon"]:checked');
        
        var dataProductId = selectedAddon.attr('data-product-id');
        var basePriceStrProduct = selectedAddon.attr('data-price-base');
        var addonPriceStr = selectedAddon.attr('data-price');

        var basePriceProduct = parseFloat(basePriceStrProduct.replace('€', '').replace(',', '.'));
        var addonPrice = parseFloat(addonPriceStr.replace('€', '').replace(',', '.'));
        
        var selectedQty = $('.activePopup .addOnQty').val();
        $('#quantity-' + dataProductId).val(selectedQty);

        var subtotalPrice = basePriceProduct + addonPrice;
        var totalPrice = subtotalPrice * selectedQty;
        var formattedPrice = totalPrice.toFixed(2).replace('.', ',');

        $('[data-product-id="' + dataProductId + '"] .confirmPrice').text(formattedPrice + ' €');
    }
    prevVal = $(this).siblings('.addOnQty').val();
});

$(document).on('click','.collection-template .content-over-media', function (e) {
        e.preventDefault(); // Prevent the default anchor behavior
        const target = $($(this).attr('href')); // Get the target element                
        if (target.length) {
            const viewportWidth = $(window).width();            
            // Define different offsets for desktop and mobile
            const offset = viewportWidth > 768 ? 270 : 200; // Adjust values as needed            
            $('html, body').animate({
                scrollTop: target.offset().top - offset
            }, 800); // Adjust duration for smoothness
        }      
      });  
   
});


const now = new Date();
const options = { timeZone: 'Europe/Berlin', hour: '2-digit', minute: '2-digit', weekday: 'long', hour12: false };
const parts = new Intl.DateTimeFormat('en-US', options).formatToParts(now);

let weekday = parts.find(p => p.type === 'weekday').value;
let hour = parseInt(parts.find(p => p.type === 'hour').value);
let minute = parseInt(parts.find(p => p.type === 'minute').value);

const totalMinutes = (hour * 60) + minute;
const allowedDays = ['Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const isLunchTime = allowedDays.includes(weekday) && totalMinutes >= 660 && totalMinutes <= 900;

// Now update ONLY elements that already have "data-lunch-menu"
$('[data-lunch-menu]').each(function() {
    $(this).attr('data-lunch-menu', isLunchTime ? 'true' : 'false');
});
